import React from 'react';
import PropTypes from 'prop-types';

import './TextLink.scss';

const TextLink = (props) => {
    const { name, href } = props;

    return (
        <a className="text-link" href={ href } target={ '_self' } rel="noopener noreferrer">
            <span>{name}</span>
        </a>
    );
}

TextLink.propTypes = {
    name: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
}

export default TextLink;